/* Mahalo Magazine posts — single source of truth, newest first.
   Used by the homepage editorial block (renders posts[0]) and
   by mahalo-magazine.html (renders the full archive). */
window.MAHALO_POSTS = [
  {
    slug: 'diacritical-matters',
    issue: 'Issue 05',
    title: 'The <i>diacritical</i> matters.',
    cover: '<i>Why</i> a vape brand started caring about the ʻokina.',
    coverGradient: 'linear-gradient(135deg, var(--ube), var(--plumeria), var(--lehua), var(--mango), var(--liliko))',
    dek: 'We use proper Hawaiian orthography — the ʻokina, the kahakō — because the language is older than us, and getting it right is the smallest, easiest aloha we can offer.',
    dek2: "Read the editor's note on why every product page, every batch label, and every line of body copy now respects the marks that tell you how a word is meant to sound.",
    byline: 'By the editors',
    date: '05/26',
    readTime: '6 min read',
    url: '#',
    cta: 'Read the issue'
  },
  {
    slug: 'shave-ice-chronicles',
    issue: 'Issue 04',
    title: 'The <i>shave-ice</i> chronicles.',
    cover: '<i>Six</i> stands. One winner.',
    coverGradient: 'linear-gradient(135deg, var(--ocean), var(--liliko), var(--mango))',
    dek: 'Six shave-ice stands across Oʻahu, ranked by syrup density, ice texture, and how generously they let the lilikoi linger.',
    dek2: 'A long, opinionated tour from Haleʻiwa to Kaimukī — with proper credit to the aunties who taught us what "shave" actually means.',
    byline: 'By J. Peʻa',
    date: '04/26',
    readTime: '9 min read',
    url: '#',
    cta: 'Read the issue'
  },
  {
    slug: 'kalos-glaze',
    issue: 'Issue 03',
    title: 'On <i>glaze.</i>',
    cover: '<i>The</i> finish that started a fight in the studio.',
    coverGradient: 'linear-gradient(135deg, #FF6C56, #FF2E4C, #A05CE0)',
    dek: 'Kalos ships with a high-gloss ceramic-style glaze. We argued about it for three months. Here is the case for shine.',
    dek2: 'Production notes, swatch tests, and the email thread where someone called it "the lipstick of the lineup."',
    byline: 'By the design team',
    date: '03/26',
    readTime: '5 min read',
    url: '#',
    cta: 'Read the issue'
  },
  {
    slug: 'rodman-debrief',
    issue: 'Issue 02',
    title: 'Rodman, <i>debriefed.</i>',
    cover: '<i>How</i> a basketball line ended up tasting like cherry pomegranate.',
    coverGradient: 'linear-gradient(135deg, #FF2E4C, #003B5C)',
    dek: 'A long conversation about court colors, buzzer-beater nostalgia, and why the Playoffs and MVP lines taste different on purpose.',
    dek2: 'Bonus: the original sketches for the steel-finish MVP shell.',
    byline: 'By M. Hale',
    date: '02/26',
    readTime: '7 min read',
    url: '#',
    cta: 'Read the issue'
  },
  {
    slug: 'pog-explained',
    issue: 'Issue 01',
    title: 'P.<i>O.</i>G., explained.',
    cover: '<i>Passion.</i> Orange. Guava. The Hawaiʻi house drink.',
    coverGradient: 'linear-gradient(135deg, var(--mango), var(--liliko), var(--lime))',
    dek: 'A short history of the islands\' unofficial juice — and why we built our flagship 7K around it.',
    dek2: 'Featuring the test panel that finally landed the ratio.',
    byline: 'By the editors',
    date: '01/26',
    readTime: '4 min read',
    url: '#',
    cta: 'Read the issue'
  }
];
